<template lang="html">
  <div id="travel-page">

    <section class="placed-backg header-banners-section-s1" v-bind:style="{ backgroundImage: 'url(public/images/pages/travel/banner-1.jpg)' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="box">
              <h1>QUIERO VIAJAR</h1>

              <p class="p-lg">
                Entérate en todo momento de las noticias más relevantes del mundo del turismo.
              </p>

              <p class="mt-4">
                <a class="btn-explore btn btn-s2 bg-white">Explora el catálogo de viajes</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container offers-section">
      <h2 class="text-center title-s1 c-primary">PAQUETES Y OFERTAS</h2>
      <h4 class="subtitle">NACIONALES E INTERNACIONALES</h4>
      <p class="mt-2 mt-lg-0 text-center">
        <a class="btn-quote btn btn-s2 bg-c-primary" target="_blank" href="https://wa.me/5213322576125">¡COTIZA YA!</a>
      </p>

      <div class="box-options">
        <a :class="'btn btn-s2 outline-cprimary b-radius btn-sm ' + (categories_id === cat.id ? 'active' : '')" @click="getTravels(cat.id)" v-for="(cat,indx) in categories" :key="indx">{{ cat.name }}</a>
      </div>

      <div class="box-carousels">
        <swiper class="swiper" :options="offersOptions">
          <swiper-slide v-for="(o, oInx) in travels" :key="'oInx-'+oInx">
            <router-link class="placed-backg box-offer" v-bind:style="{ backgroundImage: 'url('+o.imageUrl+')' }" :to="'/quiero-viajar/'+o.id">
              <div class="b-top">
                <div class="inside">
                  <h4 class="text-1">{{ o.name }}</h4>
                  <!-- <h5 class="text-2">OFERTAS ESPECIALES</h5>
                  <h6 class="text-3">{{ o.extra }}</h6> -->
                </div>
              </div>

              <div class="b-bottom">
                <span class="btn btn-s2 bg-c-primary">MÁS INFO</span>
              </div>
            </router-link>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </section>

  </div>
</template>
<script>
export default {
  data() {
    return {
      travels: [],

      // == Carousels options ==
      offersOptions: {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 30,
        centeredSlides: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 20
          },
        }
      },
      // == ==
      categories:[],
      travels:[],
      categories_id:null,
    }
  },
  methods:{
    getCategories(){
      axios.get(tools.url('/api/categories')).then((response)=>{
        this.categories = response.data;
        if(this.categories.length > 0){
            this.getTravels(this.categories[0]['id']);
        }
      }).catch((error)=>{

      })
    },
    getTravels(id){
      this.$router.push('/quiero-viajar?id='+id);
      this.categories_id = id;
      axios.get(tools.url('/api/travels/'+id)).then((response)=>{
        this.travels = response.data;
      }).catch((error)=>{

      })
    }
  },
  mounted() {
      if(this.$route.query.id){
          this.categories_id = this.$route.query.id;
          this.getTravels(this.categories_id);
      }
      this.getCategories();
  },
}
</script>
